<template>
  <div class="broadcast-history-list">
    <BroadcastHistoryBanner v-for="broadcast in broadcasts" :key="broadcast.id" :broadcast="broadcast" />

    <BroadcastHistoryBanner v-for="item in (loading ? [1, 2, 3] : [])" :key="item" loading />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import BroadcastHistoryBanner from './broadcast-history-banner'

export default {
  name: 'BroadcastHistoryList',
  components: { BroadcastHistoryBanner },
  props: {
    machineId: { type: Number, required: false, default: 0 }
  },
  computed: {
    ...mapState({
      broadcasts: state => [
        ...(state.broadcasts.execution?.data || []),
        ...(state.broadcasts.finalized?.data || [])
      ],
      zap: state => state.zaps.zap || {}
    }),
    loading() {
      return !this.broadcasts.length
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions({
      loadBroadcasts: 'broadcasts/load',
      getZap: 'zaps/get'
    }),
    async init() {
      if (Object.keys(this.zap).length == 0) {
        await this.getZap()
      }
      await this.getList()
    },
    async getList() {
      try {
        const response = await this.loadBroadcasts({
          machine_id: this.machineId,
          order_by: 'id',
          type_order: 'desc',
          page_size: 3,
          status: 2
        })
        await this.loadBroadcasts({
          machine_id: this.machineId,
          order_by: 'id',
          type_order: 'desc',
          page_size: 3 - (response.data?.length || 0),
          status: 3
        })
      } catch (_) {}
    },
    broadcast_value(broadcast) {
      const sended_count = broadcast?.sended_count || 0
      const error_count = broadcast?.error_count || 0
      const phones_count =
        broadcast?.phones?.length || broadcast?.phones_count || 1
      return parseInt(((sended_count + error_count) / phones_count) * 100)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.broadcast-history-list {
  display: flex;
  flex-direction: column;
  row-gap: $scale800;
  overflow-y: auto;
  // max-height: 704px;
}
</style>
